import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HTTPWrapperContext, RequestConfigImplementation, REQUEST_METHODS, XHR_STRATEGIES } from '@ptl/xhr';
import { BrandingConfigurationService } from '@ptl/brand';
import { ProducerStateStructure } from '../../configs/interfaces/producerStateStructure.interface';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { LOGIN_INFO_REDUCER_NAME, UserInfoStateStructure } from '@ptl/account-management';

@Injectable({
  providedIn: 'root'
})
export class MassUploadService {

  constructor(
    private httpClient: HTTPWrapperContext,
    private brandService: BrandingConfigurationService,
    private reducerUtilityService: ReducerUtilityService
  ) {
    
  } 

  async uploadFile(file: File, loginId: string): Promise<any> {
    const producerInfo: ProducerStateStructure = this.reducerUtilityService.getState('Producer');
    const loginInfo: UserInfoStateStructure = this.reducerUtilityService.getReducerFromApplicationState(LOGIN_INFO_REDUCER_NAME);

    const payload = new FormData();
    payload.append('file', file);
    payload.append('loginId', loginId);
    payload.append('agencyName', producerInfo.selectedAgency.agencyName);
    payload.append('agencyNumber', producerInfo.selectedAgency.agencyId);
    payload.append('producerNumber', producerInfo.selectedAgency.npnNo);
    payload.append('producerName', loginInfo.userInfo.firstName + " " + loginInfo.userInfo.lastName);

    const requestConfig = new RequestConfigImplementation({
      method: REQUEST_METHODS.POST,
        POST_OR_PUT_PAYLOAD: payload,
        url: '/sxesvc/api/v3/bulk-enrollment/upload',
        contentType: 'force_undefined',
        headers: new HttpHeaders({
          ddToken: this.brandService.getCurrentBrand().ddToken_encoded(),
        }),
        strategyConfigs: { forceModernUrl: true }
    });

    this.httpClient.setStrategy(XHR_STRATEGIES.AXWAY_POST_PASS);
    return this.httpClient.makeRequest(requestConfig);
  }

  async retrieveFilesByLoginId(loginId: string){

    const requestConfig = new RequestConfigImplementation({
      method: REQUEST_METHODS.GET,
        url: '/sxesvc/api/v3/mass-enrollment/fetchMassEnrollmentStatus' + "?loginId=" + loginId.toUpperCase() + "&bulkEnrollment=true",
        strategyConfigs: { forceModernUrl: true }
    });
    
    this.httpClient.setStrategy(XHR_STRATEGIES.AXWAY_POST_PASS);
    return this.httpClient.makeRequest(requestConfig);

  }

  downloadErrorLog(fileId: string): Promise<any> {
    const requestConfig = new RequestConfigImplementation({
      method: REQUEST_METHODS.GET,
      url: '/sxesvc/api/v3/bulk-enrollment/download',
      strategyConfigs: { forceModernUrl: true },
      GET_PAYLOAD: {
        fileid: fileId,
        type: "ERROR"
      }
    });

    this.httpClient.setStrategy(XHR_STRATEGIES.AXWAY_POST_PASS);
    return this.httpClient.makeRequest(requestConfig);
  }


}
